module.exports = __webpack_public_path__ + "img/compare-3.1439db1b.jpg";